import { createApp } from "vue";
// import OrderHistory from '../../common/js/views/OrderHistory.vue'; // @todo: this will be removed once top level components are made Golbal
import store from "../../common/js/store";
import registerServiceWorker from "./serviceWorkerRegistration";

// Global components import
import HongsLogo from "../../common/js/components/HongsLogo.vue";
import CsatLandingPage from "../../common/js/components/feedback/CsatLandingPage.vue";
import CsatOverallRating from "../../common/js/components/feedback/CsatOverallRating.vue";
import InitializeFeedback from "../../common/js/components/InitializeFeedback.vue";
import Ripple from "../../common/js/helpers/ripple";

const app = createApp({});
app.use(store);

// Global components registration
// @todo: similarly all other components registration currently inside Home.vue will move here and Home.vue will be discarded
app.directive("ripple", Ripple);
app.component("hongs-logo", HongsLogo);
app.component("csat-feedback", CsatLandingPage);
app.component("initialize-feedback", InitializeFeedback);
app.component("csat-overall-rating", CsatOverallRating);

app.mount("#themeDefault");

// Service worker registration
registerServiceWorker();

if (typeof window != "undefined") {
  window.onbeforeunload = () => {
    window.scrollTo(0, 0);
  };
}
